module.exports = __webpack_public_path__ + "static/value_icon-d249149592470873c791c2b15c7b3b77.svg";